import {
  Activity,
  Blocks,
  BookOpen,
  Building2,
  CircleDollarSign,
  Inbox,
  LayoutDashboard,
  Map,
  ShieldCheck,
  UserPlus,
  Users,
  type LucideIcon,
} from "lucide-react";
import type { SearchResult } from "./types";

export interface NavigationItem {
  id: string;
  to: string;
  label: string;
  searchTitle?: string;
  subtitle: string;
  keywords: string;
  icon: LucideIcon;
  exact?: boolean;
  searchType?: SearchResult["type"];
}

export interface NavigationSection {
  label: string;
  items: NavigationItem[];
}

export const NAVIGATION_SECTIONS: NavigationSection[] = [
  {
    label: "Operate",
    items: [
      { id: "dashboard", to: "/", label: "Mission control", subtitle: "Overview and service health", keywords: "dashboard home overview", icon: LayoutDashboard, exact: true },
      { id: "users", to: "/users", label: "Users", subtitle: "Accounts, sessions, and access", keywords: "people users accounts", icon: Users },
      { id: "invites", to: "/invites", label: "Invites", subtitle: "Account admission and invite lifecycle", keywords: "invites admission codes pending accepted quota", icon: UserPlus },
      { id: "evaluation-requests", to: "/evaluation-requests", label: "Evaluation requests", subtitle: "Inbound homepage form submissions", keywords: "evaluation requests leads inbound form workflow", icon: Inbox },
      { id: "organizations", to: "/organizations", label: "Organizations", subtitle: "Teams, members, and plans", keywords: "organizations teams customers", icon: Building2 },
      { id: "maps", to: "/maps", label: "Boards", subtitle: "Catalog and runtime inspection", keywords: "boards maps runtime", icon: Map },
    ],
  },
  {
    label: "Resolve",
    items: [
      { id: "objects", to: "/objects", label: "Durable Objects", subtitle: "Runtime inventory", keywords: "objects durable runtime", icon: Blocks },
      { id: "activity", to: "/activity", label: "Activity", subtitle: "Complete audit history", keywords: "audit logs activity", icon: Activity },
      { id: "commercial", to: "/commercial", label: "Plans and operations", subtitle: "Billing, Business seats, and AI costs", keywords: "commercial billing stripe subscriptions trials seats refunds reconciliation ai costs alarms overrides", icon: CircleDollarSign },
    ],
  },
  {
    label: "Build",
    items: [
      { id: "admins", to: "/admins", label: "Admin access", subtitle: "Operators, roles, and status", keywords: "admins access roles", icon: ShieldCheck },
      { id: "business", to: "/business", label: "Business system", subtitle: "Strategy, decisions, and operating records", keywords: "business strategy go to market documents decisions", icon: BookOpen, searchType: "business" },
    ],
  },
];

export const NAVIGATION_ITEMS = NAVIGATION_SECTIONS.flatMap((section) => section.items);

export const QUICK_LINKS: Array<SearchResult & { keywords: string }> = NAVIGATION_ITEMS.map((item) => ({
  id: item.id,
  type: item.searchType ?? "page",
  title: item.searchTitle ?? item.label,
  subtitle: item.subtitle,
  href: item.to,
  keywords: item.keywords,
}));
